import { HttpHeaders } from '@angular/common/http';

export const standardGetHttpOptions = {
  withCredentials: true
};

export const standardHttpOptions = {
  withCredentials: true,
  headers: new HttpHeaders({
    ['Content-Type']: 'application/json'
  })
};
